import { UserDTO as UserInfo } from '@chicilon/angular-user-service';
import { createAction, props } from '@ngrx/store';

export const register = createAction('[Auth Page] Register', props<{ username: string; password: string }>());
export const registerSuccess = createAction('[Auth Page] Register');
export const registerFailed = createAction('[Auth Page] Register', props<{ error: string }>());

export const login = createAction('[Auth Page] Login', props<{ username: string; password: string }>());
export const loginSuccess = createAction(
  '[Auth Page] Login Success',
  props<{ accessToken?: string; refreshToken?: string; expiredToken?: string; user?: UserInfo, permissionCodes?: string[]}>()
);
export const loginFailed = createAction('[Auth Page] Login Failed', props<{ error: string }>());

export const refreshAccessToken = createAction('[Auth Page] Refresh Token');

export const loadAuthFromStorage = createAction('[Auth Page] Load From Storage');

export const logout = createAction('[Auth Page] Logout');

export const updateUserInfoField = createAction(
  '[Auth Page] Update UserInfo Field',
  props<{ user?: UserInfo }>()
);

// export const otpRequired = createAction('[Auth] OTP Required', props<{ username: string }>());
// export const verifyOtp = createAction('[Auth Page] Verify OTP', props<{ username: string; otp: string }>());
// export const verifyOtpFailed = createAction('[Auth Page] Verify OTP Failed', props<{ error: string }>());
// export const verifyOtpSuccess = createAction(
//   '[Auth Page] Verify OTP Success',
//   props<{ accessToken: string; user?: UserInfo }>()
// );
